export const WEBSITE_SETTING_DETAIL = 'WEBSITE_SETTING_DETAIL'
export const WEBSITE_SETTING_UPDATE = 'WEBSITE_SETTING_UPDATE'

export default {
    WEBSITE_SETTING_DETAIL,
    WEBSITE_SETTING_UPDATE
}
